/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { RequestOwner } from '@src/app/model/RequestOwner';

/**
 * Read only - the list is only ever fetched when a request is being reassigned, with the request's
 * OMC as the forced team, so the agent side resolves through that OMC's primary agent.
 */
@Injectable({
    providedIn: 'root'
})
export class RequestOwnerService extends AbstractHttpService {
    protected http = inject(HttpClient);
    protected messageService = inject(MessageService);

    protected get baseUrl() {
        return this.getAjaxPath('requestOwners');
    }

    protected cache: RequestOwner[];
    protected typeString = 'Request Owner';
}
